import { useBunja } from 'bunja/react';
import { useSetAtom } from 'jotai';
import Link from 'next/link';

import { recentHistoryBunja } from '@flipster/features/src/recent-history/state';
import { OrderAttributionMapper, orderAttributionAtom } from '@flipster/features/src/shared/order-attribution';
import { useSnapshotSpec } from '@flipster/features/src/shared/snapshot/use-snapshot-spec';
import { css } from '@flipster/styled-system/css';
import { flex } from '@flipster/styled-system/patterns';
import segment from '@flipster/utils/segment';
import { MarketEvent } from '@flipster/utils/segment/events/market';
import { TradeEvent } from '@flipster/utils/segment/events/trade';

import { MarginBadge } from './margin-badge';

export const RecentSearchHistoryItem = ({
  symbol,
  index,
  onClickItem,
}: {
  symbol: string;
  index: number;
  onClickItem?: () => void;
}) => {
  const setOrderAttribution = useSetAtom(orderAttributionAtom);
  const { addRecentSearchHistory } = useBunja(recentHistoryBunja);
  const { instrumentsKeyBySymbol } = useSnapshotSpec();

  const symbolInfo = instrumentsKeyBySymbol?.[symbol];

  const handleSearchHistory = (isSpot: boolean) => {
    addRecentSearchHistory(symbol);

    setOrderAttribution(OrderAttributionMapper.market.searchRecentHistory);
    segment.track(MarketEvent.SearchHistoryClick, {
      trade_type: isSpot ? 'spot' : 'perpetual',
      symbol,
    });
    segment.track(TradeEvent.TradeCryptoClick, {
      trade_type: isSpot ? 'spot' : 'perpetual',
      symbol,
      carousel_type: 'Recent history',
      list_order: index,
      search_type: null,
      search_word: null,
      price_change_percentage: null,
    });
  };

  if (!symbolInfo || !symbolInfo.isListed) return null;

  return (
    <li>
      <Link
        href={symbolInfo.isSpot ? `/trade/spot/${symbol}` : `/trade/perpetual/${symbol}`}
        onClick={() => {
          handleSearchHistory(symbolInfo.isSpot);
          onClickItem?.();
        }}
        className={flex({
          alignItems: 'center',
          backgroundColor: 'background.default.level-3',
          borderRadius: '1000px',
          p: 6,
          pl: 12,
          gap: '4px',
          '&:hover': {
            boxShadow: '0 0 0 1px {colors.border.default.level-2} inset',
          },
        })}
      >
        <span className={css({ textStyle: 'Text/M/Regular', color: 'content.default.level-5' })}>
          {symbolInfo.displayShortName}
        </span>
        <MarginBadge marginType={symbolInfo.isSpot ? 'spot' : 'perpetual'} />
      </Link>
    </li>
  );
};
